import React from "react";
import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { EditTable } from '@synergy/table';
import { notification, Flex, Modal, Button, Row, Col } from 'antd';
import useFetch from "../../../../../../server/useFetch";
import query from "../../../../../../server/constants.api";
import Spinner from "../../../../Atomics/Spinner";
import { Text } from "../../../../Atomics/Text";
import  {FormModal}  from "../../../../Atomics/FormModal";
import { useAuthContext } from "../../../../../../contexts/AuthContext";


export const CertificationTable = ({ certificationTableRef, isCertificationTableLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { checkToken } = useAuthContext();
  const [api, contextHolder] = notification.useNotification();

  const [addNewRowModalOpen, setAddNewRowModalOpen] = useState(false);
  const [addNewRow, setAddNewRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [isToAddNewRow, setIsToAddNewRow] = useState(false);
  const [isToDeleteRow, setIsToDeleteRow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchDownload, setFetchDownload] = useState(false);
  const [docFileName, setDocFileName] = useState('');
  const [docFileNameToDownload, setDocFileNameToDownload] = useState('');
  const [certificationList, setCertificationsList] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const disabledDateCertificate = (current) => {
    const minDate = new Date();
    return current && (current < minDate);
  };

  const { data: certificationsListData, isLoading: certificationsIsLoading, refetch: refetchCertifications, error: certificationsListDataError
  } = useFetch(query.path.getCerteficatesListById, 'getCerteficatesListById',
    { id: id });

  const { data: downloadCertificate, isLoading: downloadCertificateIsLoading, refetch: refetchDownloadCertificate
  } = useFetch(query.path.getCertificateDocument, 'getCertificateDocument',
    { id: docFileName }, fetchDownload);

  const {
    data: addCertificate,
    isLoading: addCertificateIsLoading,
    error: addCertificateError
  } = useFetch(query.path.addCertificateDocument, 'getAddCertificateDocument',
    {
      id: id,
      values: addNewRow
    }, isToAddNewRow, 'POST');

  const {
    data: deleteCertificate,
    isLoading: deleteCertificateIsLoading,
    error: deleteCertificateError
  } = useFetch(query.path.deleteCertificateDocument, 'getDeleteCertificateDocument',
    {
      id: deleteRow
    }, isToDeleteRow);

    /* useEffect(() => {
      isCertificationTableLoading(certificationsIsLoading)
    }, [certificationsIsLoading]); */

  useEffect(() => {
    if (certificationsListData?.data) {
      setCertificationsList(certificationsListData?.data);
      setLoading(false);
    } else if (certificationsListDataError) {
      console.log('Error: Register detail, error obtaining certificate documents', certificationsListDataError)
    }
  }, [certificationsListData, certificationsListDataError])

  useEffect(() => {

    try {
      if (downloadCertificate?.data) {
        // Convert base64 to binary
        const binaryData = atob(downloadCertificate?.data);
        const byteNumbers = new Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          byteNumbers[i] = binaryData.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob object
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        // Specify the filename
        link.download = docFileNameToDownload;

        // Simulate a click on the link to trigger the download
        link.click();

        setDownloadLoader(false)
      }

    }
    catch (error) {
      console.error('download certificate file error: ', error);
    }
    finally {
      setFetchDownload(false);
    }
  }, [downloadCertificate])

  const handleSubmitNewRow = (values) => {
    checkToken();//Validate token
    setAddNewRow(values);
    setAddNewRowModalOpen(false);
  };
  useEffect(() => {
    if (addNewRow) {
      setLoading(true);
      setIsToAddNewRow(true)
    }
  }, [addNewRow])

  const handleDownload = (record) => {
    setDownloadLoader(true);
    setDocFileName(record['File URL'])
    setDocFileNameToDownload(record['Filename'])
  };

  useEffect(() => {
    if (docFileName) {
      setFetchDownload(true);
    }
  }, [docFileName])

  const handleDelete = (record) => {
    setDeleteRow(record?.id)
  };
  useEffect(() => {
    if (deleteRow) {
      setLoading(true);
      setIsToDeleteRow(true)
    }
  }, [deleteRow])

  useEffect(() => {
    if (deleteCertificate?.status == 200) {
      setIsToDeleteRow(false);
      refetchCertifications();
      api.success({
        message: t('success'),
        description: t('successDelete'),
        placement: 'topRight',
        duration: 5,
      });
    } else if (deleteCertificateError) {
      api.error({
        message: t('errorDelete'),
        placement: 'topRight',
        duration: 5,
      });
      setLoading(false);
    }
  }, [deleteCertificate, deleteCertificateError])

  useEffect(() => {
    if (addCertificate?.status == 200) {
      setIsToAddNewRow(false);
      refetchCertifications();
      api.success({
        message: t('success'),
        description: t('successAdd'),
        placement: 'topRight',
        duration: 5,
      });
    } else if (addCertificateError) {
      api.error({
        message: t('errorAdd'),
        placement: 'topRight',
        duration: 5,
      });
      setLoading(false);
    }
  }, [addCertificate, addCertificateError])

  return (
    <Flex id='Energetic certification' className='ant-anchors-content-item' gap={32} vertical="true">
      <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('Energetic Certification')}</Text>

      {loading ?
        <Flex align="center" justify="center">
          <Spinner stroke="green" size='30px' />
        </Flex>
        :
        <div ref={certificationTableRef}>
          <EditTable
            fetchData={certificationList}
            tableId='energeticCertificationTable'
            deleteButton={true}
            handleDelete={(e) => handleDelete(e)}
            hidePagination={false}
            handleDownload={(e) => handleDownload(e)}
            // hrefLink={'https://' + integrations_apiKey + '.execute-api.eu-west-1.amazonaws.com/v3_0_01' + query.path.downloadCertificateDocument}
            language={i18next.resolvedLanguage}
            downloadLoader={downloadLoader}
          />
        </div>
      }
      <Row>
        <Col span={4} offset={20}>
          <Flex justify="flex-end" horizontal="true">
            {loading ?
              null
              :
              <Button className='ant-btn-blue -small' type="primary" onClick={(e) => { setAddNewRowModalOpen(true) }}>{t('add')}</Button>
            }
            {contextHolder}
            <Modal
              title={t('add')}
              centered
              open={addNewRowModalOpen}
              onOk={() => setAddNewRowModalOpen(false)}
              onCancel={() => setAddNewRowModalOpen(false)}
              footer={null}
            >
              <FormModal
                onFinish={(values) => handleSubmitNewRow(values)}
                data={{
                  layout: {
                    labelCol: 6,
                    wrapperCol: 12,
                    layout: 'horizontal',
                  },
                  items: [
                    {
                      label: t('name'),
                      name: 'name',
                      input: 'input',
                      key: 'name',
                      required: true
                    },
                    {
                      label: t('expirationDate'),
                      name: 'date',
                      input: 'date',
                      key: 'date',
                      required: true
                    },
                    {
                      label: t('energyClass'),
                      name: 'energyClass',
                      input: 'select',
                      options: ['A+', 'A', 'B', 'B-', 'C', 'D', 'E', 'F'],
                      key: 'energyClass',
                      required: true
                    },
                    {
                      label: t('upload'),
                      name: 'upload',
                      input: 'upload',
                      icon: 'Upload',
                      valuePropName: 'fileList',
                      key: 'upload',
                      maxFiles: 1,
                      required: true
                    }
                  ]
                }} />
            </Modal>
          </Flex>
        </Col>
      </Row>

    </Flex>
  )
}